const MVCObject = require("../mvcobject").MVCObject;

/**
 * @memberOf woosmap.utils
 * @extends woosmap.utils.MVCObject
 */
class DelegateReturn {
    /**
     * Builds a delegate return value.
     * @constructor
     */
    constructor() {
        this.value = undefined;
        this.called = false;
    }

    /**
     * Returns `defaultValue` when the delegate was not called.
     * Else return the delegate return value.
     * @param {*} defaultValue
     * @returns {*}
     */
    or(defaultValue) {
        if (!this.called) {
            return defaultValue;
        }
        return this.value;
    }
}

/**
 * @abstract
 * @class DelegateProtocol
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.utils
 */
class DelegateProtocol extends MVCObject {
    /**
     * Constructs a new DelegateProtocol
     * @constructor
     */
    constructor() {
        super();

        /**
         * The delegate object.
         * @type {Object}
         */
        this.delegate = null;
    }

    /**
     * Calls the method `methodName` on the delegate.
     * @param {String} methodName the method to call.
     * @returns {woosmap.utils.DelegateReturn}
     */
    callDelegateMethod(methodName) {
        const returnValue = new DelegateReturn();
        if (this.delegate) {
            const delegateMethod = this.delegate[methodName];
            if (delegateMethod) {
                returnValue.value = this.delegate[methodName].apply(this, Array.prototype.slice.call(arguments, 1));
                returnValue.called = true;
            }
        }
        return returnValue;
    }
}

exports.DelegateProtocol = DelegateProtocol;
